export const money = (amount) => {
  let money = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return money.format(Number(amount / 100));
};